import React from 'react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

const LOGO_CANDIDATES = [
  process.env.REACT_APP_PDF_LOGO,
  '/logobigua.PNG',
  '/DRIZA_LOGO3.png',
  '/DRIZA_LOGO.png',
].filter(Boolean);

export default function PrecuentaImprimible({
  mesa,
  sesion,
  pedidos = [],
  consumoTotal = 0,
  propina = 0,
  total = 0,
}) {
  const logo = LOGO_CANDIDATES[0];

  const items = pedidos.flatMap(
    (pedido) => pedido.items || []
  );

  return (
    <div id="restaurante-precuenta" className="hidden print:block">
      <div className="mx-auto w-[72mm] bg-white p-3 text-black">
        <div className="text-center">
          {logo && (
            <img
              src={`${process.env.PUBLIC_URL || ''}${logo}`}
              alt="Logo"
              className="mx-auto mb-3 max-h-20 max-w-[55mm] object-contain"
            />
          )}

          <h1 className="text-lg font-bold">PRECUENTA</h1>
          <p className="text-xs">Comprobante de consumo</p>
        </div>

        <div className="my-3 border-t border-dashed border-black" />

        <div className="space-y-1 text-xs">
          <p>
            <strong>Mesa:</strong>{' '}
            {mesa?.alias || mesa?.nombre || '-'}
          </p>

          {mesa?.alias && mesa?.nombre && (
            <p>
              <strong>Referencia:</strong> {mesa.nombre}
            </p>
          )}

          <p>
            <strong>Comensales:</strong>{' '}
            {sesion?.comensales || 1}
          </p>

          <p>
            <strong>Fecha:</strong>{' '}
            {new Date().toLocaleString('es-AR')}
          </p>
        </div>

        <div className="my-3 border-t border-dashed border-black" />

        <div className="space-y-2 text-xs">
          {items.map((item) => (
            <div key={item.id}>
              <div className="flex justify-between gap-3">
                <span>
                  {item.cantidad} × {item.producto_nombre}
                </span>

                <span>{money(item.subtotal)}</span>
              </div>

              <div className="text-[10px]">
                {money(item.precio_unitario)} c/u
              </div>
            </div>
          ))}
        </div>

        <div className="my-3 border-t border-dashed border-black" />

        <div className="space-y-1 text-sm">
          <div className="flex justify-between">
            <span>Consumo</span>
            <strong>{money(consumoTotal)}</strong>
          </div>

          {Number(propina) > 0 && (
            <div className="flex justify-between">
              <span>Propina sugerida</span>
              <strong>{money(propina)}</strong>
            </div>
          )}

          <div className="mt-2 flex justify-between text-base">
            <strong>TOTAL</strong>
            <strong>{money(total)}</strong>
          </div>
        </div>

        <div className="my-3 border-t border-dashed border-black" />

        <div className="text-center text-[10px]">
          <p>Precuenta informativa.</p>
          <p>No registra ningún pago.</p>
        </div>
      </div>
    </div>
  );
}
